"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CatHome32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M19 21h-6v7H9c-1.288 0-2-.713-2-2v-9H3.75c-.602 0-1.01-.144-1.18-.535-.15-.348-.03-.677.233-1.02.098-.128.219-.258.357-.39.204-.194.405-.356.514-.434a624.083 624.083 0 011.822-1.563c1.37-1.173 2.745-2.345 4.038-3.44l.148-.125C14.198 5.671 15.627 4.5 16 4.5c.374 0 1.806 1.174 6.318 4.993l.149.125a1002.06 1002.06 0 015.828 4.978c.14.103.34.265.545.46.138.131.258.261.357.39.263.342.383.67.232 1.018-.17.392-.577.536-1.179.536H25v9c0 1.288-.71 2-1.998 2H19v-7zm-7 6v-7h8v7h3.002c.734 0 .998-.264.998-1V16h4.25l.109-.001a2.806 2.806 0 00-.21-.22 5.203 5.203 0 00-.476-.4 621.143 621.143 0 00-1.82-1.562 1001.09 1001.09 0 00-4.033-3.435l-.148-.126a348.641 348.641 0 00-4.01-3.354 62.183 62.183 0 00-1.36-1.09A12.86 12.86 0 0016 5.585c-.082.06-.183.135-.302.227a62.41 62.41 0 00-1.36 1.09c-1.02.836-2.385 1.979-4.01 3.354l-.148.126a1004.946 1004.946 0 00-5.354 4.568l-.53.454a4.757 4.757 0 00-.446.375 2.804 2.804 0 00-.209.22L3.75 16H8v10c0 .735.265 1 1 1h3zm4.17-21.532a.714.714 0 00.006-.003l-.005.003zm-.333.005a.52.52 0 00-.012-.007l.012.007z", className: "cat-home-32_svg__path-1" }))); };
var StyledCatHome32 = styled_components_1.default(CatHome32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatHome32;
var templateObject_1;
//# sourceMappingURL=CatHome32.js.map